module.exports = __webpack_public_path__ + "static/assets/cbdf6ab9a751d5ad11692e66e04f066a.png";